import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./baseQuery";

export const apiSlice = createApi({
  baseQuery: baseQuery,
  tagTypes: [
    "Video",
    "Coupons",
    "Destination",
    "Destinations",
    "dONATION",
    "Expenses",
    "Guide",
    "Gear",
    "Order",
    "Gallery",
    "Product",
    "QrStats",
    "Blog",
    "AdminProfile",
    "Milestones",
    "Donation",
    "Coupon",
    "Cart",
    "ContactMessages",
    "User",
    "LegalDocuments",
    "Itinerary",
  ],
  endpoints: () => ({}), // Leave empty, extend with injectEndpoints
});
